import { gql } from '@apollo/client';

const getStoreDetailsQuery = () => {
  const query = `
    query storeDetails($storeId: String!) {
      storeDetails(storeId: $storeId) {
        storeId
        storeName
        phone
        distance
        address {
          street
          city
          state
          country
          postalCode
        }
        __typename
      }
    }
  `;
  return gql(query);
};
export default getStoreDetailsQuery;